import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FileInfo, Szza007aRequest, Szza016aResponse, ResponseCommon } from 'sg-api';
import { ToastMessageService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UsedSzza007aService } from '../services/used-szza007a.service';
import { UsedSzza016aService } from '../services/used-szza016a.service';

@Component({
  selector: 'app-file-download',
  templateUrl: './sgkd017d.component.html',
  styleUrls: ['./sgkd017d.component.scss'],
})
export class Sgkd017dComponent implements OnInit {
  /** ファイルリスト取得条件 */
  searchConditionForm: UntypedFormGroup = this.fb.group({});
  /** ファイルリスト取得結果 */
	response: Szza016aResponse;
	/** responseCommon */
	responseCommon: ResponseCommon;
  /** ファイル情報 */
  responseList: Array<FileInfo> | null = null;
  /** ファイルリスト取得済みフラグ */
  searched: boolean = false;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** ファイルリスト取得条件 */
  searchCondition: any;

  /**
   * コンストラクタ
   * @memberof FileDownloadComponent
   */
  constructor(private fb: UntypedFormBuilder,
      private usedSzza016aService: UsedSzza016aService,
      private usedSzza007aService: UsedSzza007aService,
      private toastMessageService: ToastMessageService) {
  }

  /**
   * 初期処理
   * @memberof FileDownloadComponent
   */
  ngOnInit(): void {
    // 受信データの購読設定（ファイルリスト）
    this.usedSzza016aService.fileListValueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(response => {
          this.response = response;
          this.responseCommon = response.responseCommon;
          this.responseList = response.responseList;
    });
  }

  /**
   * クリアボタン押下時に、検索結果を非表示化する
   * @memberof FileDownloadComponent
   */
  onClickClear(): void {
    this.searched = false;
  }

  /**
   * SZZA016Aを実行し、ファイル一覧を取得
   * @memberof FileDownloadComponent
   */
  getFileList(): void {
    // ファイルリスト取得済みフラグを初期化
    this.searched = false;
    // ダウンロードの際に使用するため、ここで保持しておく
    this.searchCondition = this.searchConditionForm.getRawValue();
    
    // ファイルリスト取得API実行
    this.usedSzza016aService.getFileList(this.searchCondition).subscribe(result => {
      this.searched = true;
    });
  }

  /**
   * ファイルダウンロード実行
   * @param row
   * @memberof FileDownloadComponent
   */
  fileDownload(row: FileInfo): void {
    const request: Szza007aRequest = {
      systemCode: this.searchCondition.systemCode,
      fileCategory: this.searchCondition.fileCategory,
      name: row.fileName
    };
    this.usedSzza007aService.fileDownload(request).subscribe(result => {
      if (result == false) {
        this.toastMessageService.addError('ファイル名が指定されていません');
      }
    });
  }
}
